import "./style.css";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import * as dat from "dat.gui";
import px from "./textures/environmentMaps/0/px.jpg";
import nx from "./textures/environmentMaps/0/nx.jpg";
import py from "./textures/environmentMaps/0/py.jpg";
import ny from "./textures/environmentMaps/0/ny.jpg";
import pz from "./textures/environmentMaps/0/pz.jpg";
import nz from "./textures/environmentMaps/0/nz.jpg";

const scene = new THREE.Scene();
//camera
const camera = new THREE.PerspectiveCamera(
  45,
  window.innerWidth / window.innerHeight,
  1,
  1000
);
camera.position.z = 15;
scene.add(camera);
//Group
const group = new THREE.Group();
//axis helper
const axisHelper = new THREE.AxesHelper(10);
scene.add(axisHelper);
//gui
const gui = new dat.GUI();
//texture
const environmentTextrue = new THREE.CubeTextureLoader().load([
  px,
  nx,
  py,
  ny,
  pz,
  nz,
]);

//material
const material = new THREE.MeshStandardMaterial();
material.side = THREE.DoubleSide;
material.envMap = environmentTextrue;

//geometry
const sphereGeometry = new THREE.SphereGeometry(2, 32, 16);
const planeGeometry = new THREE.PlaneGeometry(5, 5, 10, 10);
const torusGeometry = new THREE.TorusGeometry(2, 0.5, 16, 100);
// Mesh
const sphereMesh = new THREE.Mesh(sphereGeometry, material);
const planeMesh = new THREE.Mesh(planeGeometry, material);
const torusMesh = new THREE.Mesh(torusGeometry, material);
sphereMesh.position.x = -10;
torusMesh.position.x = 10;
group.add(sphereMesh);
group.add(planeMesh);
group.add(torusMesh);
scene.add(group);

//Gui
material.metalness = 0;
material.roughness = 1;
material.envMapIntensity = 1;
gui.add(material, "metalness").min(0).max(1).step(0.0001);
gui.add(material, "roughness").min(0).max(1).step(0.0001);
gui.add(material, "envMapIntensity").min(0).max(5).step(0.01);

//renderer
const renderer = new THREE.WebGLRenderer({ antialias: true });
renderer.setSize(window.innerWidth, window.innerHeight);
renderer.render(scene, camera);
const controls = new OrbitControls(camera, renderer.domElement);
controls.update();
document.body.appendChild(renderer.domElement);
// Light setup
const ambientLight = new THREE.AmbientLight(0xffffff, 0.5); // dimmer ambient
scene.add(ambientLight);
const pointLight = new THREE.PointLight(0xffffff, 0.5); // brightness = 1
pointLight.position.set(5, 5, 10);
scene.add(pointLight);
// light helper
const pointLightHelper = new THREE.PointLightHelper(pointLight, 1);
scene.add(pointLightHelper);

window.addEventListener("resize", () => {
  renderer.setSize(window.innerWidth, window.innerHeight);
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
});

function animate() {
  controls.update();
  renderer.render(scene, camera);
  requestAnimationFrame(animate);
}
animate();
console.log("this is webpack threejs");
